import React from 'react';
import { observer } from 'mobx-react-lite';

import useUser from 'src/hooks/use-user';
import { useLoyalty } from 'src/hooks/use-loyalty';
import { ConsumerSection } from './consumer-section';
import { BaseButton, ButtonContainer, ConsumerInfoContainer, EndSessionButton } from './consumer-info.styles';

type ConsumerInfoProps = {
  createPublicContextSessionLoading: boolean;
  goToCart: () => void;
  kioskProModalLogin: () => Promise<void>;
  orderSubTotal?: number;
  startNewSession: () => void;
};

export const ConsumerInfo = observer(
  ({
    createPublicContextSessionLoading,
    goToCart,
    kioskProModalLogin,
    orderSubTotal,
    startNewSession,
  }: ConsumerInfoProps): JSX.Element => {
    const User = useUser();
    const isUserLoggedIn = User.isLoggedIn;
    const userFirstName = User.firstName;
    const guestPhoneNumber = User.kioskGuestPhoneNumber;

    const { loyaltyPoints, isAlpineIQEnabled, isDutchiePOSLoyaltyEnabled, isSpringbigEnabled } = useLoyalty();
    const hasLoyaltyIntegration = isAlpineIQEnabled || isDutchiePOSLoyaltyEnabled || isSpringbigEnabled;
    const hasGuestPhone = !isUserLoggedIn && !!guestPhoneNumber;

    return (
      <ConsumerInfoContainer $isUserLoggedIn={isUserLoggedIn || hasGuestPhone}>
        <ConsumerSection
          createPublicContextSessionLoading={createPublicContextSessionLoading}
          guestPhoneNumber={guestPhoneNumber}
          hasGuestPhone={hasGuestPhone}
          hasLoyaltyIntegration={hasLoyaltyIntegration}
          isUserLoggedIn={isUserLoggedIn}
          kioskProModalLogin={kioskProModalLogin}
          loyaltyPoints={loyaltyPoints}
          userFirstName={userFirstName}
        />

        <ButtonContainer>
          <EndSessionButton onClick={startNewSession}>End Session</EndSessionButton>
          <BaseButton onClick={goToCart}>Cart ${(orderSubTotal ?? 0).toFixed(2)}</BaseButton>
        </ButtonContainer>
      </ConsumerInfoContainer>
    );
  }
);
